/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  WebflowFaqCategoriesResponseDto,
  WebflowFaqsResponseDto
} from '.././model'
import { customFetcher } from '../../../client/customFetcher';



/**
 * @summary Get all FAQ categories from Webflow
 */
export const webflowControllerGetFaqCategories = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<WebflowFaqCategoriesResponseDto>(
      {url: `/webflow/faq-categories`, method: 'GET', signal
    },
      );
    }
  

export const getWebflowControllerGetFaqCategoriesQueryKey = () => {
    return [`/webflow/faq-categories`] as const;
    }

    
export const getWebflowControllerGetFaqCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebflowControllerGetFaqCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>> = ({ signal }) => webflowControllerGetFaqCategories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type WebflowControllerGetFaqCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>>
export type WebflowControllerGetFaqCategoriesQueryError = unknown

/**
 * @summary Get all FAQ categories from Webflow
 */
export const useWebflowControllerGetFaqCategories = <TData = Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqCategories>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWebflowControllerGetFaqCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get all FAQs from Webflow
 */
export const webflowControllerGetFaqs = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<WebflowFaqsResponseDto>(
      {url: `/webflow/faqs`, method: 'GET', signal
    },
      );
    }
  

export const getWebflowControllerGetFaqsQueryKey = () => {
    return [`/webflow/faqs`] as const;
    }

    
export const getWebflowControllerGetFaqsQueryOptions = <TData = Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebflowControllerGetFaqsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof webflowControllerGetFaqs>>> = ({ signal }) => webflowControllerGetFaqs(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData> & { queryKey: QueryKey }
}

export type WebflowControllerGetFaqsQueryResult = NonNullable<Awaited<ReturnType<typeof webflowControllerGetFaqs>>>
export type WebflowControllerGetFaqsQueryError = unknown

/**
 * @summary Get all FAQs from Webflow
 */
export const useWebflowControllerGetFaqs = <TData = Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof webflowControllerGetFaqs>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWebflowControllerGetFaqsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



